import React from 'react'
import { Navigate, RouteObject } from 'react-router'
import MainLayout from '../app/layout/Main'
import DashboardPage from '../app/pages/Dashboard.page'
import DevPage from '../app/pages/Development.page'
import ImportsPage from '../app/pages/Imports.page'
import NewImportPage from '../app/pages/NewImport.page'
import OauthPage from '../app/pages/Oauth.page'
import TrackingPage from '../app/pages/Tracking.page'
import { TPageUrl } from './accessMap'
import SettingsPage from '../app/pages/Settings.page'

export const siteMap = (pageAccessMap: Record<TPageUrl, boolean>): RouteObject[] => [
  {
    path: '/',
    element: pageAccessMap['/dashboard'] ? <MainLayout /> : <Navigate to='/oauth/signIn' />,
    children: [
      {
        index: true,
        path: '/dashboard',
        element: pageAccessMap['/dashboard'] ? <DashboardPage /> : <Navigate to='/oauth/signIn' />,
      },
      {
        path: '/new-import',
        element: pageAccessMap['/new-import'] ? <NewImportPage /> : <Navigate to='/oauth/signIn' />,
      },
      {
        path: '/imports',
        element: pageAccessMap['/imports'] ? <ImportsPage /> : <Navigate to='/oauth/signIn' />,
      },
      {
        path: '/tracking',
        element: pageAccessMap['/tracking'] ? <TrackingPage /> : <Navigate to='/oauth/signIn' />,
      },
      {
        path: '/settings',
        element: pageAccessMap['/settings'] ? <SettingsPage /> : <Navigate to='/oauth/signIn' />,
      },
    ],
  },

  // --
  // -- Ouath routes
  // --
  {
    path: '/oauth/signIn',
    element: pageAccessMap['/oauth/signIn'] ? <OauthPage flow='signIn' /> : <Navigate to='/' />,
  },
  {
    path: '/oauth/signUp',
    element: pageAccessMap['/oauth/signUp'] ? <OauthPage flow='signUp' /> : <Navigate to='/' />,
  },
  {
    path: '/oauth/remind',
    element: pageAccessMap['/oauth/remind'] ? <OauthPage flow='remind' /> : <Navigate to='/' />,
  },
  {
    path: '/oauth/activate',
    element: pageAccessMap['/oauth/activate'] ? <OauthPage flow='activate' /> : <Navigate to='/' />,
  },

  // --
  // -- Development routes
  // --
  {
    path: '/dev',
    element: pageAccessMap['/dev'] ? <DevPage /> : <Navigate to='/oauth/signIn?original-url=' />,
  },

  {
    path: '*',
    element: <Navigate to='/' />,
  },
]
